var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	5850: () => (loadStrictSingletonVersion("default", "react", true, [1,18,3,1], () => (() => (__webpack_require__(6540))))),
	2282: () => (loadStrictSingletonVersion("default", "react-dom", true, [1,18,3,1], () => (() => (__webpack_require__(961))))),
	455: () => (loadStrictVersion("default", "crypto-js", false, [1,4,2,0], () => (Promise.all([__webpack_require__.e(396), __webpack_require__.e(477)]).then(() => (() => (__webpack_require__(1396))))))),
	919: () => (loadStrictVersion("default", "rehype-sanitize", false, [1,6,0,0], () => (__webpack_require__.e(617).then(() => (() => (__webpack_require__(3617))))))),
	1079: () => (loadStrictVersion("default", "lodash", false, [1,4,17,21], () => (__webpack_require__.e(543).then(() => (() => (__webpack_require__(2543))))))),
	1084: () => (loadStrictVersion("default", "rehype-raw", false, [1,7,0,0], () => (Promise.all([__webpack_require__.e(429), __webpack_require__.e(867)]).then(() => (() => (__webpack_require__(1867))))))),
	1105: () => (loadStrictVersion("default", "react-frame-component", false, [1,5,2,7], () => (__webpack_require__.e(522).then(() => (() => (__webpack_require__(6522))))))),
	1351: () => (loadStrictVersion("default", "tailwind-merge", false, [1,2,5,4], () => (__webpack_require__.e(856).then(() => (() => (__webpack_require__(856))))))),
	2026: () => (loadStrictVersion("default", "uuid", false, [1,11,0,3], () => (__webpack_require__.e(221).then(() => (() => (__webpack_require__(3221))))))),
	2249: () => (loadStrictVersion("default", "@ricky0123/vad-react", false, [3,0,0,28], () => (__webpack_require__.e(506).then(() => (() => (__webpack_require__(2506))))))),
	2438: () => (loadStrictVersion("default", "js-cookie", false, [1,3,0,5], () => (__webpack_require__.e(987).then(() => (() => (__webpack_require__(8987))))))),
	2467: () => (loadStrictVersion("default", "@react-oauth/google", false, [2,0,12,1], () => (__webpack_require__.e(306).then(() => (() => (__webpack_require__(2306))))))),
	2564: () => (loadStrictVersion("default", "axios", false, [1,1,8,4], () => (__webpack_require__.e(447).then(() => (() => (__webpack_require__(4447))))))),
	2843: () => (loadStrictVersion("default", "clsx", false, [1,2,1,1], () => (__webpack_require__.e(164).then(() => (() => (__webpack_require__(4164))))))),
	2861: () => (loadStrictVersion("default", "lucide-react", false, [2,0,474,0], () => (__webpack_require__.e(92).then(() => (() => (__webpack_require__(5092))))))),
	4067: () => (loadStrictVersion("default", "react-markdown", false, [1,9,0,1], () => (Promise.all([__webpack_require__.e(429), __webpack_require__.e(104)]).then(() => (() => (__webpack_require__(6104))))))),
	5056: () => (loadStrictVersion("default", "react-router-dom", false, [1,7,1,1], () => (__webpack_require__.e(142).then(() => (() => (__webpack_require__(3142))))))),
	5335: () => (loadStrictVersion("default", "zustand", false, [1,5,0,2], () => (__webpack_require__.e(618).then(() => (() => (__webpack_require__(5618))))))),
	5387: () => (loadStrictVersion("default", "react-hook-form", false, [1,7,53,2], () => (__webpack_require__.e(785).then(() => (() => (__webpack_require__(9785))))))),
	7321: () => (loadStrictVersion("default", "utf8", false, [1,3,0,0], () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(31))))))),
	8654: () => (loadStrictVersion("default", "react-lottie-player", false, [1,2,1,0], () => (__webpack_require__.e(200).then(() => (() => (__webpack_require__(3200))))))),
	8762: () => (loadStrictVersion("default", "@module-federation/utilities", false, [1,3,1,32], () => (__webpack_require__.e(636).then(() => (() => (__webpack_require__(6636))))))),
	9057: () => (loadStrictSingletonVersion("default", "reactflow", true, [1,11,11,4], () => (() => (__webpack_require__(1048))))),
	9072: () => (loadStrictVersion("default", "react-resizable-panels", false, [1,2,1,7], () => (__webpack_require__.e(27).then(() => (() => (__webpack_require__(9027))))))),
	9073: () => (loadStrictVersion("default", "wavesurfer.js", false, [1,7,8,9], () => (__webpack_require__.e(949).then(() => (() => (__webpack_require__(9949))))))),
	9234: () => (loadStrictVersion("default", "graphql-ws", false, [1,5,16,0], () => (__webpack_require__.e(930).then(() => (() => (__webpack_require__(3930)))))))
};
var initialConsumes = [5850,2282];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"562": [
		455,
		919,
		1079,
		1084,
		1105,
		1351,
		2026,
		2249,
		2438,
		2467,
		2564,
		2843,
		2861,
		4067,
		5056,
		5335,
		5387,
		7321,
		8654,
		8762,
		9057,
		9072,
		9073,
		9234
	],
	"792": [
		5850,
		2282
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}